import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { getUninstallableReason } from '../utils/installability';
function getAppInstallability({
  offeringId
}) {
  return http.get(`ecosystem/v1/apps/${offeringId}/installability`);
}
const GET_APP_INSTALLABILITY = registerQuery({
  fieldName: 'appInstallability',
  args: ['offeringId'],
  fetcher: getAppInstallability
});
export function useAppInstallability({
  appContext = 'app',
  // default to app context
  offeringId
}) {
  var _result$data;
  const result = useQuery(GET_APP_INSTALLABILITY, {
    variables: {
      offeringId
    },
    skip: appContext !== 'app' || !offeringId
  });
  const uninstallableReason = ((_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.appInstallability) && getUninstallableReason(result.data.appInstallability);
  return Object.assign({}, result, {
    uninstallableReason
  });
}